// Constant
import { ApiFailedConstant } from 'constant'

// Interfaces
import { IBaseApiResponse } from 'interfaces/api'

/**
 * @description Get success response api
 *
 * @param {number} status
 * @param {any} response
 *
 * @return {BaseApiSuccess} BaseApiSuccess
 */
export const api_getSuccessResponse = (status: number | string, response: any): IBaseApiResponse<{ res: any }> => {
  const { res, config, ok, headers } = response

  const baseResponse = {
    ok,
    config,
    res,
    status,
    headers,
    message: response?.message,
  }

  return baseResponse
}

/**
 * @description Get failed response api
 *
 * @param {number|string} status
 * @param {any} response
 *
 * @return {BaseApiFailed} BaseApiFailed
 */
export const api_getFailedResponse = (status: number | string, response: any): IBaseApiResponse<{ res: any }> => {
  const { res, config } = response

  const baseResponse = {
    ok: false,
    config,
    res,
    status,
  }

  // Check if theres any error outside the http status code
  switch (status) {
    case 'ECONNABORTED':
      return {
        ...baseResponse,
        message: res?.message || ApiFailedConstant.TIMEOUT,
      }
    case 'NETWORKERROR':
      return {
        ...baseResponse,
        message: res?.message || ApiFailedConstant.NETWORK_ERROR,
      }
    default:
      return { ...response, ...baseResponse }
  }
}
